module.exports = __webpack_public_path__ + "assets/boxicons.f46ca69e63f9c5f080203c3f510b4110.ttf";